// pages/FormViewerPage/sections/FormHeaderSection.tsx — Badge checkout aman DIHAPUS 2026-10-30
// (0 form aktif). Komponen dipertahankan sbg no-op agar caller (FullFormBody/WizardBody) tak berubah.
import React from 'react';
import type { Form } from '../../../types';

export const FormHeaderSection: React.FC<{ form: Form; blockSpacingClass: string; descriptionClasses: string }> = () => null;
